import { AnalyticsEvent, AnalyticsEventTemplate, EventName } from './analytics-event';

export class UploadEvent implements AnalyticsEvent {
  event: EventName = 'upload';

  upload_text?: string;
  field_name?: string;

  constructor(template: AnalyticsEventTemplate<UploadEvent> = {}) {
    Object.assign(this, template);
  }
}
